<template>
    <v-app>
        <v-card>
            <v-card-title class="headline mt-8 justify-center">
                Termos de Serviço — ZaperMenu
            </v-card-title>

            <v-card-text style="text-align: justify; padding: 24px 40px;">
                <div style="max-width: 700px; margin: auto;">
                    <p><strong>Última atualização:</strong> 04/08/2025</p>

                    <p><strong>Bem-vindo ao ZaperMenu!</strong><br>
                    Estes Termos de Serviço (“Termos”) regem o uso da plataforma ZaperMenu, de propriedade da <strong>Scheeren Company LTDA</strong>, inscrita no CNPJ nº 50.515.044/0001-22, com sede na Avenida Brasília, nº 1933, Centro, Pinhalzinho/SC – CEP 89870-000.</p>

                    <p>Ao utilizar o ZaperMenu, você concorda com estes Termos. Caso não concorde, não utilize nossos serviços.</p>

                    <v-divider class="my-3"/>

                    <h3>1. Objeto</h3>
                    <p>O ZaperMenu é uma plataforma digital para gestão de cardápios, pedidos, comandas e demais funcionalidades voltadas para estabelecimentos alimentícios, disponível via web e aplicativos compatíveis.</p>

                    <v-divider class="my-3"/>

                    <h3>2. Cadastro e Conta</h3>
                    <ul>
                        <li>Para utilizar o ZaperMenu, é necessário criar uma conta, fornecendo informações verdadeiras e completas.</li>
                        <li>Você é responsável por manter a confidencialidade do seu login e senha.</li>
                        <li>O uso indevido ou fraudulento poderá resultar na suspensão ou exclusão da conta.</li>
                    </ul>

                    <v-divider class="my-3"/>

                    <h3>3. Uso da Plataforma</h3>
                    <ul>
                        <li>É proibido utilizar o ZaperMenu para atividades ilegais, fraudulentas ou que infrinjam direitos de terceiros.</li>
                        <li>O usuário é responsável pelo conteúdo inserido na plataforma (ex.: nomes de produtos, preços, imagens).</li>
                        <li>O ZaperMenu poderá, a seu critério, suspender ou encerrar contas que violem estes Termos.</li>
                    </ul>

                    <v-divider class="my-3"/>

                    <h3>4. Planos, Pagamentos e Reajustes</h3>
                    <ul>
                        <li>O ZaperMenu não trabalha com planos gratuitos. Em alguns casos, poderá ser oferecido um período de teste gratuito, normalmente de <strong>7 dias</strong>.</li>
                        <li>Planos pagos são cobrados de forma recorrente (mensal, anual ou conforme contratado).</li>
                        <li>A falta de pagamento poderá resultar na suspensão do serviço.</li>
                        <li>Podemos aplicar reajustes nos valores dos planos, a fim de manter o equilíbrio econômico-financeiro do serviço, de acordo com a variação do <strong>IGP-M (Índice Geral de Preços do Mercado)</strong> ou outro índice que venha a substituí-lo.</li>
                    </ul>

                    <v-divider class="my-3"/>

                    <h3>5. Cancelamento</h3>
                    <ul>
                        <li>O usuário pode cancelar a qualquer momento via e-mail ou entrando em contato com nosso suporte.</li>
                        <li>Pagamentos já realizados não são reembolsáveis, exceto quando previsto em lei.</li>
                    </ul>

                    <v-divider class="my-3"/>

                    <h3>6. Limitação de Responsabilidade</h3>
                    <ul>
                        <li>O ZaperMenu se compromete a manter a plataforma funcional e segura, mas não garante disponibilidade ininterrupta.</li>
                        <li>Não nos responsabilizamos por prejuízos causados por:
                        <ul>
                            <li>Problemas na conexão de internet do usuário.</li>
                            <li>Indisponibilidade temporária por manutenção.</li>
                            <li>Uso indevido por terceiros com acesso à sua conta.</li>
                            <li>Bloqueios ou restrições impostos por plataformas externas (ex.: WhatsApp, Meta, provedores de pagamento).</li>
                            <li>Informações inseridas ou geradas nos sistemas, tais como valores, relatórios, ou qualquer outro dado.</li>
                        </ul>
                        </li>
                        <li>Apesar de nos esforçarmos para manter o sistema preciso, podem ocorrer bugs, falhas técnicas ou limitações. O ZaperMenu não assume nenhuma responsabilidade e não pode ser responsabilizado por quaisquer danos diretos, indiretos, incidentais ou consequenciais que possam surgir a partir de problemas técnicos, limitações, bugs, falhas de segurança ou vírus, em conexão com o acesso ou uso da plataforma, seu conteúdo ou serviços.</li>
                    </ul>

                    <v-divider class="my-3"/>

                    <h3>7. Propriedade Intelectual</h3>
                    <p>Todo o conteúdo, código e design do ZaperMenu são protegidos por direitos autorais e não podem ser copiados, modificados ou distribuídos sem autorização.</p>

                    <v-divider class="my-3"/>

                    <h3>8. Privacidade</h3>
                    <p>O tratamento de dados pessoais segue nossa <strong>Política de Privacidade</strong>, disponível em:<br>
                    <code>https://admin.zapermenu.com.br/politica-de-privacidade</code></p>

                    <v-divider class="my-3"/>

                    <h3>9. Alterações nos Termos</h3>
                    <ul>
                        <li>Podemos alterar estes Termos a qualquer momento. A versão atualizada será publicada no site.</li>
                        <li>O uso contínuo da plataforma após alterações significa que você aceita as mudanças.</li>
                    </ul>

                    <v-divider class="my-3"/>

                    <h3>10. Contato</h3>
                    <p>Para dúvidas ou solicitações sobre estes Termos:<br>
                    <strong>E-mail:</strong> contato@zapermenu.com.br<br>
                    <strong>WhatsApp:</strong> (49) 9 8895-1210<br>
                    <strong>Endereço:</strong> Avenida Brasília, nº 1933, Centro, Pinhalzinho/SC – CEP 89870-000</p>
                </div>
            </v-card-text>
        </v-card>
    </v-app>
</template>

<script>
export default {
    name: 'TermosServico',
};
</script>
